<template>
    <div class="registration-survey-component mb-5">
        <label class="label" v-if="component.type != 'content'">
            {{ component.label }}
            <span class="has-text-weight-normal has-text-danger ml-1 tag" v-if="required">required</span>
            <!--  <span class="has-text-weight-normal has-text-grey ml-1 tag" v-if="!required">optional</span> -->
        </label>  


        <Address v-if="component.type == 'address'" :component="component" v-model="answer" :required="required" />

        <Checkbox v-if="component.type == 'checkbox'" :component="component" v-model="answer" :required="required" />

        <Content v-if="component.type == 'content'" :component="component" v-model="answer" />

        <DateTime v-if="component.type == 'datetime'" :component="component" v-model="answer" :required="required" />

        <Day v-if="component.type == 'day'" :component="component" v-model="answer" :required="required" />

        <Email v-if="component.type == 'email'" :component="component" v-model="answer" :required="required" />

        <PhoneNumber v-if="component.type == 'phoneNumber'" :component="component" v-model="answer" :required="required" />

        <Select v-if="component.type == 'select'" :component="component" v-model="answer" :required="required" />

        <SelectBoxes v-if="component.type == 'selectboxes'" :component="component" v-model="answer" :required="required" />

        <Signature v-if="component.type == 'signature'" :component="component" v-model="answer" :required="required" />

        <Textarea v-if="component.type == 'textarea'" :component="component" v-model="answer" :required="required" />

        <Textfield v-if="component.type == 'textfield'" :component="component" v-model="answer" :required="required" />

        <Time v-if="component.type == 'time'" :component="component" v-model="answer" :required="required" />

      <Radio v-if="component.type == 'radio'" :component="component" v-model="answer" :required="required" />
    </div>
</template>

<script>
var debounce = require('lodash.debounce');

import Address from './Address.vue'
import Checkbox from './Checkbox.vue'
import Content from './Content.vue'
import DateTime from './DateTime.vue'
import Day from './Day.vue'
import Email from './Email.vue'
import PhoneNumber from './PhoneNumber.vue'
import Select from './Select.vue'
import SelectBoxes from './SelectBoxes.vue'
import Signature from './Signature.vue'
import Textarea from './Textarea.vue'
import Textfield from './Textfield.vue'
import Time from './Time.vue'
import Radio from './Radio'


export default {
    name: 'SurveyComponent',
    components: {
        Address,
        Checkbox,
        Content,
        DateTime,
        Day,
        Email,
        PhoneNumber,
        Select,
        SelectBoxes,
        Signature,
        Textarea,
        Textfield,
        Time,
      Radio,
    },
    props: {
        component: Object,
        questionResponse: Object
    },
    data: function () {
        return {
            // surveyQuestionResponses: Array
        }
    },
    methods: {
        setQuestionResponse(answer) {
            // console.log(this.component.questionId + ': ' + answer);
            this.$emit('input', this.component.questionId, answer)
        }
    },
    mounted(){
        // // console.log(this.questionResponse)
    },     
    computed: {
        answer: {
            get: function () {
                if (this.questionResponse) {
                    return this.questionResponse.answer
                }

                return null
            },
            set: function (newValue) {
                // this.questionResponse.answer = newValue
                // // console.log(newValue)
                this.setQuestionResponse(newValue)
            }
        },
        required () {
            return this.component.validate && this.component.validate.required
        }
    }
}

</script>

<style>
.is-required {
    font-weight: normal;
}
.is-optional {
    font-weight: normal;
    color: #ccc;
}
</style>

